export default "__VITE_ASSET__Bxjv39Et__"